import React from "react";

const GRADIENTS = [
  "linear-gradient(135deg,#3dc53a,#258626)",
  "linear-gradient(135deg,#6c757d,#343a40)",
  "linear-gradient(135deg,#7c3aed,#4c1d95)",
  "linear-gradient(135deg,#2563eb,#1e3a8a)",
  "linear-gradient(135deg,#d97706,#92400e)",
  "linear-gradient(135deg,#0ea5e9,#0c4a6e)",
];

const STATUS_DOT = {
  working: "var(--kr-success-500)",
  paused: "var(--kr-warning-500)",
  off: "var(--kr-neutral-400)",
  away: "var(--kr-neutral-400)",
  finished: "var(--kr-info-500)",
};

function gradientFor(name) {
  const safe = (name || "?").toString();
  let h = 0;
  for (let i = 0; i < safe.length; i++) {
    h = (h * 31 + safe.charCodeAt(i)) >>> 0;
  }
  return GRADIENTS[h % GRADIENTS.length];
}

function initialsFor(name) {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  const first = parts[0][0] || "";
  const last = parts.length > 1 ? parts[parts.length - 1][0] : "";
  return (first + last).toUpperCase() || "?";
}

export function Avatar({ name = "??", size = 28, status, src, style }) {
  const dot = STATUS_DOT[status];
  const dotSize = Math.max(8, Math.round(size * 0.28));
  return (
    <span
      style={{
        position: "relative",
        width: size,
        height: size,
        borderRadius: 999,
        background: src ? "transparent" : gradientFor(name),
        color: "#fff",
        fontWeight: 600,
        fontSize: Math.round(size * 0.4),
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        overflow: "hidden",
        ...(style || {}),
      }}
    >
      {src ? (
        <img
          src={src}
          alt=""
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      ) : (
        initialsFor(name)
      )}
      {dot && (
        <span
          style={{
            position: "absolute",
            bottom: -1,
            right: -1,
            width: dotSize,
            height: dotSize,
            borderRadius: 999,
            background: dot,
            border: "2px solid var(--kr-bg-surface)",
          }}
        />
      )}
    </span>
  );
}

export default Avatar;
